import BaseComponent from 'scripts/BaseComponent.js';
import { AccessibilityHelper } from 'scripts/accessibility/accessibilityHelper';
import UnderlayHelper from '../../global/underlay-helper';

export default class NavigationMobile extends BaseComponent {
  constructor(component) {
    super(component);

    this.debug = false;

    this.refs = {
      body: 'body',
      header: '.js-header',
      navigation: '.js-navigation',
      mobileNavOpen: '.js-mobileNavOpen',
      mobileNavClose: '.js-mobileNavClose',
      navMenuBtns: '.js-navMenuOpen',
      backBtns: '.js-menuBack',
      sidebar: '.js-sidebar',
      subMenu: '.js-navSubMenu',
      mobileSearch: '.js-searchMobile',
    };

    this.dom = {
      $component: component,
      $body: document.querySelector(this.refs.body),
      $navigation: document.querySelector(this.refs.navigation),
      $header: document.querySelector(this.refs.header),
      $mobileNavOpenBtn: document.querySelector(this.refs.mobileNavOpen),
      $mobileNavCloseBtns: [...document.querySelectorAll(this.refs.mobileNavClose)],
      $navMenuBtns: this.$getAll(this.refs.navMenuBtns),
      $backBtns: this.$getAll(this.refs.backBtns),
      $sidebar: this.$get(this.refs.sidebar),
      $subMenu: this.$getAll(this.refs.subMenu),
      $mobileSearch: this.$get(this.refs.mobileSearch),
    };

    this.state = {
      mobileNavOpen: false,
      openSubMenu: '',
      activeClass: 'is-active',
      fixedClass: 'is-fixed',
      closeMobileNavDrawerEvent: 'closemobilenavdrawer',
      subMenuClass: this.refs.subMenu,
      underlayHelper: new UnderlayHelper(),
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
      closeSearchEvent: 'closesearchdrawer',
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    this.setClick(dom.$mobileNavOpenBtn, this.openMobileNav);
    this.setClick(dom.$mobileNavCloseBtns, this.closeMobileNav);
    this.setOnCustomEvent(state.closeMobileNavDrawerEvent, this.closeMobileNav);
    this.setClickWithElement(dom.$navMenuBtns, this.openSubMenu);
    this.setClick(dom.$backBtns, this.closeSubMenu);
    this.setOnEscapeKey(this.closeMobileNav);
    state.underlayHelper.addClickListener(this.closeMobileNav.bind(this));
    state.accessibilityHelper.updateElementAccessibility(dom.$sidebar, false);
  }

  openMobileNav() {
    const { dom, state } = this;
    dom.$sidebar.setAttribute('aria-hidden', 'false');
    dom.$sidebar.setAttribute('aria-expanded', 'true');
    dom.$sidebar.classList.add(state.activeClass);
    dom.$navigation.classList.add(state.activeClass);
    dom.$header.classList.add(state.activeClass);
    state.underlayHelper.open();
    dom.$body.classList.add(state.fixedClass);
    state.mobileNavOpen = true;
    this.setOpenNavAccessibility();
  }

  closeMobileNav() {
    const { dom, state } = this;
    this.dispatch(state.closeSearchEvent);

    if (state.mobileNavOpen) {
      dom.$sidebar.setAttribute('aria-hidden', 'true');
      dom.$sidebar.setAttribute('aria-expanded', 'false');
      dom.$sidebar.classList.remove(state.activeClass);
      dom.$navigation.classList.remove(state.activeClass);
      dom.$header.classList.remove(state.activeClass);
      dom.$body.classList.remove(state.fixedClass);
      state.underlayHelper.close();
      state.mobileNavOpen = false;

      if (state.openSubMenu) {
        setTimeout(() => {
          this.closeSubMenu();
          this.setClosedNavAccessibility();
        }, 500);
      } else {
        this.setClosedNavAccessibility();
      }
    }
  }

  openSubMenu(subMenu) {
    const { state } = this;
    const subMenuUrl = subMenu.dataset.sublinks;
    const $activeSubMenu = this.getActiveSubMenu(subMenuUrl);
    $activeSubMenu.classList.add(state.activeClass);
    state.openSubMenu = subMenuUrl;
    this.setOpenSubMenuAccessibility($activeSubMenu);
  }

  closeSubMenu() {
    const { dom, state } = this;
    const $activeSubMenu = this.getActiveSubMenu(state.openSubMenu);
    const $activeBtn = dom.$navMenuBtns.find(($el) => $el.dataset.sublinks === state.openSubMenu);
    $activeSubMenu.classList.remove(state.activeClass);
    state.openSubMenu = '';
    this.setClosedSubMenuAccessibility($activeBtn);
  }

  getActiveSubMenu(openSubMenuUrl) {
    const { dom, state } = this;
    const subMenuSelector = `${state.subMenuClass}[data-sublinks="${openSubMenuUrl}"]`;
    return dom.$component.querySelector(subMenuSelector);
  }

  setOpenNavAccessibility() {
    const { dom, state } = this;
    state.accessibilityHelper.updateElementAccessibility(dom.$sidebar, true);
    state.accessibilityHelper.updateElementAccessibility(dom.$subMenu, false);
    state.focusTrap = state.accessibilityHelper.buildFocusTrap(dom.$sidebar);
    state.focusTrap.set();
  }

  setClosedNavAccessibility() {
    const { dom, state } = this;
    state.accessibilityHelper.updateElementAccessibility(dom.$sidebar, false);
    if (state.focusTrap) { state.focusTrap.unset(); }
    dom.$mobileNavOpenBtn.focus();
  }

  setOpenSubMenuAccessibility($activeSubMenu) {
    const { dom, state } = this;
    state.accessibilityHelper.updateElementAccessibility(dom.$sidebar, false);
    // state.accessibilityHelper.updateElementAccessibility(dom.$mobileSearch, true);
    state.accessibilityHelper.updateElementAccessibility($activeSubMenu, true);
    state.focusTrap = state.accessibilityHelper.buildFocusTrap(dom.$sidebar);
    state.focusTrap.set();
  }

  setClosedSubMenuAccessibility($activeMenuBtn) {
    const { dom, state } = this;
    state.accessibilityHelper.updateElementAccessibility(dom.$sidebar, true);
    state.accessibilityHelper.updateElementAccessibility(dom.$subMenu, false);
    if (state.focusTrap) { state.focusTrap.unset(); }
    $activeMenuBtn.focus();
  }
}
